// src/app/features/muskoka/muskoka.module.ts
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';

// Muskoka components
import {MuskokaDashboardComponent} from './components/dashboard/muskoka-dashboard.component';
import {MuskokaListingsSearchComponent} from './components/search-filter/muskoka-listings-search.component';
import {MuskokaListingDetailsFullComponent} from './components/listing-details/muskoka-listing-details-full.component';

// Muskoka Sold
import {SoldDashboardComponent} from './sold-properties/sold-dashboard/sold-dashboard.component';

// Muskoka services
import {MuskokaListingsService} from './services/muskoka-listings.service';
import {MuskokaRoutingModule} from "./muskoka-routing.module";
import {LISTINGS_SERVICE_TOKEN} from "../../core/services/listings-service.token";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SharedModule,
    MuskokaRoutingModule,

    // Standalone components
    MuskokaDashboardComponent,
    MuskokaListingDetailsFullComponent,
    MuskokaListingsSearchComponent,
    SoldDashboardComponent
  ],
  providers: [
    MuskokaListingsService,
    {provide: LISTINGS_SERVICE_TOKEN, useClass: MuskokaListingsService}

  ]
})
export class MuskokaModule {
}
